import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid'
import Box from '@mui/material/Box'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import Tooltip from '@mui/material/Tooltip';
import { useDispatch, useSelector } from 'react-redux'
import { obtenerSolicitudesACEstatusNacional } from '../../../redux/DuckOrganismoCertificacion/EstatusSolicitudesUIF01Duck'

function SolicitudesAtendidasACComponent(props) {

    const dispatch = useDispatch()
    const solicitudes = useSelector(store => store.EstatusSolicitudesUIF01.estatusSolicitudesACNacional)

    React.useEffect(async () => {
        await dispatch(obtenerSolicitudesACEstatusNacional(2))
    }, [])
    const columns = [
        { field: 'folio', headerAlign: 'center', headerName: 'Folio', width: 130, resizable: true },
        { field: 'FechaDecreación', headerAlign: 'center', headerName: 'Fecha de solicitud', width: 150, resizable: true },
        { field: 'tipoSolicitud', headerAlign: 'center', headerName: 'Tipo Solicitud', width: 280, resizable: true },
        { field: 'noSocio', headerAlign: 'center', headerName: 'No. de socio', width: 110, resizable: true },
        { field: 'nombreRazon', headerAlign: 'center', headerName: 'Razón social', width: 250, resizable: true },
        { field: 'Revisor', headerAlign: 'center', headerName: 'Ejecutivo de AC', width: 180, resizable: true },
        { field: 'estatus', headerAlign: 'center', headerName: 'Estatus', width: 180, resizable: true },
    ]

    const rows = []
    solicitudes?.fc_01_solicitudderegistro?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)

        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]

        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'

        let folio = ''
        /*if(solicitud?.idestatusdesolicitudes != 4)*/folio = solicitud.folio
        //else folio= solicitud?.informacionmodalaceptada?.numerosolicitudservicios

        rows.push({
            id: uuidv4(), id: solicitud.idfc01_solicitudregistro, folio: folio,
            noSocio: solicitud.numerosocio !== undefined ? solicitud.numerosocio?.toString().length > 0 ? solicitud.numerosocio : '' : '',
            FechaDecreación: fecha, tipoSolicitud: 'Solicitud de inscripción', nombreRazon: solicitud.nombrerazonsocial,
            Nombre: 'fc_01_solicitudderegistro', idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '',
            estatus: estatus
        })
    })
    solicitudes?.fc_08_solicitudrenvacioncertificados?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        rows.push({
            id: uuidv4(), folio: solicitud.folio, Folio: solicitud.idfc08_renvacioncertificado, FechaDecreación: fecha,
            tipoSolicitud: 'Solicitud de renovación de certificados', nombreRazon: solicitud.nombrerazonsocial,
            noSocio: solicitud.numerocliente, Nombre: 'fc_08_solicitudrenvacioncertificados',
            idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus
        })
    })
    solicitudes?.fc_33_solicitudenvasadonacional?.map(solicitud => {
        let revisor = ''
        let nombre = solicitud.revisor?.split(' ')
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        rows.push({
            id: uuidv4(), Folio: solicitud.idfc33_solicitudenvasadonaciona, folio: solicitud.folio, FechaDecreación: solicitud.fechasolicitud.substring(0, 10),
            idlogin: solicitud.idlogin, tipoSolicitud: 'Solicitud de venta nacional', Revisor: nombre?.[0] !== undefined ? revisor : '',
            nombreRazon: solicitud.nombrecliente, noSocio: solicitud.numerocliente, estatus: estatus
        })
    })
    solicitudes?.fc_36_solicituddeactualizacion?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]

        let accion = ''
        if (solicitud.cambiorazon) accion = 'Cambio de razón social o régimen fiscal'
        else {
            if (solicitud.actualizaciondomicilio) accion = 'Actualización de domicilio fiscal'
            if (solicitud.cambioresponsable) accion = 'Actualización de persona autorizada para trámite'
            if (solicitud.cambiorepresentante) accion = 'Actualización de representante legal'
            if (solicitud.actualizarmedioscontacto) accion = 'Actualización medios de contacto'
            if (solicitud.actualizacioncadena) accion = 'Actualización de cadena productiva'
            if (solicitud.cambioresponsableinst) accion = 'Actualización de responsables de instalaciones'
            if (solicitud.actualizacioninstalaciones) accion = 'Alta o baja instalaciones'
            if (solicitud.actualizacionprediosviveros) accion = 'Baja predios/viveros'
            if (solicitud.actualizarmarcas) accion = 'Actualización de marcas'
        }

        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'

        rows.push({
            id: uuidv4(), Folio: solicitud.idfc36_solicitudactualizacion,
            folio: solicitud.folio, tipoSolicitud: 'Solicitud de actualización: ' + accion, noSocio: solicitud.numerocliente,
            FechaDecreación: fecha, idlogin: solicitud.idlogin, nombreRazon: solicitud.nombrerazonsocial,
            Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus
        })
    })
    solicitudes?.fc_41_solicitudparabebidasconmezcal?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]

        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        rows.push({
            id: uuidv4(), Folio: solicitud.idfc41_solicitudparabebidasconm,
            folio: solicitud.folio, tipoSolicitud: 'Solicitud para productos con mezcal', noSocio: solicitud.numerocliente,
            FechaDecreación: fecha, idlogin: solicitud.idlogin, nombreRazon: solicitud.nombrerazonsocial,
            Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus
        })

    })

    const theme = createTheme({
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
        }
    });

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <ThemeProvider theme={theme}>
                    <GridToolbarQuickFilter style={{ backgroundColor: '#F4F6F6', width: '100%', fontFamily: 'Montserrat' }} placeholder='Búsqueda...' />
                </ThemeProvider>
            </Box>
        );
    }

    return (
        <Fragment>
            <div className='container'>
                <h3 className='text-center mt-5 pt-3' style={{ fontWeight: 'bolder', fontFamily: 'Montserrat' }}>SOLICITUDES ATENDIDAS EN AC</h3><br />
                <div style={{ height: 600, width: '100%', color: 'black', paddingTop: 0 }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        components={{ Toolbar: QuickSearchToolbar }}
                        getRowHeight={() => 'auto'}
                        sx={{
                            boxShadow: 0,
                            color: 'black',
                            border: 0,
                            fontFamily: 'Montserrat',
                            '& .MuiDataGrid-cell': {
                                display: 'block',
                                position: 'relative',
                                textAlign: 'center',
                                paddingTop: '10px',
                                paddingBottom: '15px'
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#0C365A',
                                color: 'white',
                                fontFamily: 'Montserrat',
                                fontWeight: 'bold',
                                height: '20px'
                            }
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(SolicitudesAtendidasACComponent)